import React from 'react';
import { FixedWithContainer } from '../common/CardBoardStyled';
import Spinner from '../../components/Spinner';
import BodyView from './components/BodyView';
import DefaultReinforcements from './components/DefaultReinforcements';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';

interface ReinforcementsViewProps {
  courses: any[];
  selectReinforcement: (id: string, courseId: string) => void;
  reinforcementCards: {
    reinforcements: any[];
    featureds: any[];
    subscriptions: number;
    eventsWaitingList: any[];
  };
  setSelectCourse: (courseId: string) => void;
  isLoadingCourses: boolean;
  isLoadingReinforcements: boolean;
  selectedCourse: string;
  goBackButton: () => void;
  courseIndex: number;
  selectIndex: (courseId: number) => void;
  subsectionHeader: any;
}

const ReinforcementsView = (props: ReinforcementsViewProps) => {
  const {
    selectReinforcement,
    reinforcementCards,
    setSelectCourse,
    selectedCourse,
    isLoadingCourses,
    isLoadingReinforcements,
    courses,
    goBackButton,
    courseIndex,
    selectIndex,
    subsectionHeader
  } = props;
  const Content = () => (
    <div data-testid="cmp-reinforcements-content">
      {courses && courses.length ? (
        <BodyView
          courses={courses}
          selectReinforcement={selectReinforcement}
          reinforcementCards={reinforcementCards}
          isLoadingReinforcements={isLoadingReinforcements}
          setSelectCourse={setSelectCourse}
          selectedCourse={selectedCourse}
          courseIndex={courseIndex}
          selectIndex={selectIndex}
        />
      ) : (
        <DefaultReinforcements />
      )}
    </div>
  );

  return (
    <ModuleContainer containerType="subsection">
      <SubsectionHeader
        title={subsectionHeader[1].title}
        onClick={goBackButton}
      />
      <FixedWithContainer>
        {isLoadingCourses ? <Spinner /> : <Content />}
      </FixedWithContainer>
    </ModuleContainer>
  );
};

export default ReinforcementsView;
